import { PLATFORMS } from '@constants';

export const VATNumber = 'P. IVA FR19752979930';

export const aboutLinks = {
  [PLATFORMS.FRANCE]: [
    {
      id: 'footer.legal.mentions',
      href: 'footer.legal.mentions.href',
      dataQa: 'legalCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.protection',
      href: 'footer.legal.protection.href',
      dataQa: 'dataProtectCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.manage.cookies',
      href: 'footer.legal.manage.cookies.href',
      dataQa: 'dataManageCookiesCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.terms',
      href: 'footer.legal.terms.href',
      dataQa: 'termsAndConditionsCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.consumption.information',
      href: 'footer.legal.consumption.information.href',
      dataQa: 'consumptionInformationCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.sitemap.deals',
      href: 'footer.sitemap.deals.href',
      dataQa: 'siteMapVPCta',
    },
    {
      id: 'footer.sitemap.advice',
      href: 'footer.sitemap.advice.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.product.categories',
      href: 'footer.sitemap.product.categories.href',
      dataQa: 'siteMapMasslandingCta',
    },
    {
      id: 'footer.sitemap.top.products',
      href: 'footer.sitemap.top.products.href',
      dataQa: 'siteMapTopProductsCta',
    },
    {
      id: 'footer.sitemap',
      href: 'footer.sitemap.href',
      dataQa: 'siteMapCta',
    },
  ],
  [PLATFORMS.SPAIN]: [
    {
      id: 'footer.legal.mentions',
      href: 'footer.legal.mentions.href',
      dataQa: 'legalCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.protection',
      href: 'footer.legal.protection.href',
      dataQa: 'dataProtectCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.manage.cookies',
      href: 'footer.legal.manage.cookies.href',
      dataQa: 'dataManageCookiesCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.terms',
      href: 'footer.legal.terms.href',
      dataQa: 'termsAndConditionsCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.consumption.information',
      href: 'footer.legal.consumption.information.href',
      dataQa: 'consumptionInformationCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.sitemap.deals',
      href: 'footer.sitemap.deals.href',
      dataQa: 'siteMapVPCta',
    },
    {
      id: 'footer.sitemap.advice',
      href: 'footer.sitemap.advice.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.product.categories',
      href: 'footer.sitemap.product.categories.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.top.products',
      href: 'footer.sitemap.top.products.href',
      dataQa: 'siteMapTopProductsCta',
    },
    {
      id: 'footer.sitemap',
      href: 'footer.sitemap.href',
      dataQa: 'siteMapCta',
    },
  ],
  [PLATFORMS.GREAT_BRITAIN]: [
    {
      id: 'footer.legal.mentions',
      href: 'footer.legal.mentions.href',
      dataQa: 'legalCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.protection',
      href: 'footer.legal.protection.href',
      dataQa: 'dataProtectCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.manage.cookies',
      href: 'footer.legal.manage.cookies.href',
      dataQa: 'dataManageCookiesCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.terms',
      href: 'footer.legal.terms.href',
      dataQa: 'termsAndConditionsCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.consumption.information',
      href: 'footer.legal.consumption.information.href',
      dataQa: 'consumptionInformationCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.sitemap.deals',
      href: 'footer.sitemap.deals.href',
      dataQa: 'siteMapVPCta',
    },
    {
      id: 'footer.sitemap.advice',
      href: 'footer.sitemap.advice.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.product.categories',
      href: 'footer.sitemap.product.categories.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.top.products',
      href: 'footer.sitemap.top.products.href',
      dataQa: 'siteMapTopProductsCta',
    },
    {
      id: 'footer.sitemap',
      href: 'footer.sitemap.href',
      dataQa: 'siteMapCta',
    },
  ],
  [PLATFORMS.ITALY]: [
    {
      id: 'footer.legal.mentions',
      href: 'footer.legal.mentions.href',
      dataQa: 'legalCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.protection',
      href: 'footer.legal.protection.href',
      dataQa: 'dataProtectCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.manage.cookies',
      href: 'footer.legal.manage.cookies.href',
      dataQa: 'dataManageCookiesCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.terms',
      href: 'footer.legal.terms.href',
      dataQa: 'termsAndConditionsCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.consumption.information',
      href: 'footer.legal.consumption.information.href',
      dataQa: 'consumptionInformationCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.sitemap.deals',
      href: 'footer.sitemap.deals.href',
      dataQa: 'siteMapVPCta',
    },
    {
      id: 'footer.sitemap.advice',
      href: 'footer.sitemap.advice.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.product.categories',
      href: 'footer.sitemap.product.categories.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.top.products',
      href: 'footer.sitemap.top.products.href',
      dataQa: 'siteMapTopProductsCta',
    },
    {
      id: 'footer.sitemap',
      href: 'footer.sitemap.href',
      dataQa: 'siteMapCta',
    },
  ],
  [PLATFORMS.GERMANY]: [
    {
      id: 'footer.legal.mentions',
      href: 'footer.legal.mentions.href',
      dataQa: 'legalCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.protection',
      href: 'footer.legal.protection.href',
      dataQa: 'dataProtectCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.manage.cookies',
      href: 'footer.legal.manage.cookies.href',
      dataQa: 'dataManageCookiesCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.terms',
      href: 'footer.legal.terms.href',
      dataQa: 'termsAndConditionsCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.legal.consumption.information',
      href: 'footer.legal.consumption.information.href',
      dataQa: 'consumptionInformationCta',
      rel: 'nofollow',
    },
    {
      id: 'footer.sitemap.deals',
      href: 'footer.sitemap.deals.href',
      dataQa: 'siteMapVPCta',
    },
    {
      id: 'footer.sitemap.advice',
      href: 'footer.sitemap.advice.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.product.categories',
      href: 'footer.sitemap.product.categories.href',
      dataQa: 'siteMapAdviceCta',
    },
    {
      id: 'footer.sitemap.top.products',
      href: 'footer.sitemap.top.products.href',
      dataQa: 'siteMapTopProductsCta',
    },
    {
      id: 'footer.sitemap',
      href: 'footer.sitemap.href',
      dataQa: 'siteMapCta',
    },
  ],
};
